import React from "react";
import { cx } from "../../utils/classNames";

export function AppLoader({
  label = "Loading...",
  sublabel,
  variant = "block",
  className,
}) {
  return (
    <div className={cx("app-loader", `app-loader-${variant}`, className)}>
      <div className="app-loader-orb" aria-hidden="true">
        <span className="app-loader-ring app-loader-ring-a" />
        <span className="app-loader-ring app-loader-ring-b" />
        <span className="app-loader-core" />
      </div>

      <div className="app-loader-copy">
        <div className="app-loader-label">{label}</div>
        {sublabel ? <div className="app-loader-sublabel">{sublabel}</div> : null}
      </div>
    </div>
  );
}

export default AppLoader;
